import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { hasWarehouseDevice } from '@/shared/auth/warehouseDeviceStorage'
import { hasWarehouseSession } from '@/shared/auth/warehouseSessionStorage'
import { useClientHydrated } from '@/shared/hooks/useClientHydrated'

export function WarehouseGuard({ children }: { children: ReactNode }) {
  const hydrated = useClientHydrated()

  if (!hydrated) {
    return <div className="min-h-screen bg-surface" aria-hidden />
  }
  if (!hasWarehouseDevice()) {
    return <Navigate to="/warehouse/activate" replace />
  }
  if (!hasWarehouseSession()) {
    return <Navigate to="/warehouse/login" replace />
  }
  return <>{children}</>
}
